import { format } from 'date-fns';
import { Card, Col } from 'react-bootstrap';

import { COLLECTION_DATE_FORMAT } from '../constants';
import { type DOI } from '../utils/doi';
import { DOIBadge } from './DOIBadge';
import { MetadataElement } from './MetadataElement';
import { MetadataElementList } from './MetadataElementList';
import { Publisher } from './Publisher';

export function DOIInstrumentMetadata({ doi }: { doi: DOI }) {
  const createdDate = doi.createdDate
    ? format(doi.createdDate, COLLECTION_DATE_FORMAT)
    : undefined;

  // A `Coverage` date can be a single date or a `start/end` range
  const [operationalStart, operationalEnd] = doi.operationalPeriod
    ? doi.operationalPeriod.split('/')
    : [];

  return (
    <Card>
      <Card.Header className="p-2">Metadata</Card.Header>
      <Card.Body className="pt-0 p-2">
        <Col>
          <MetadataElement title="Identifier">
            <DOIBadge doi={doi.doi} />
          </MetadataElement>

          <MetadataElementList
            title={`Instrument Alias${doi.aliases && doi.aliases.length > 1 ? 'es' : ''}`}
            values={doi.aliases}
          />

          {!!doi.owners?.length && (
            <MetadataElement title={`Owner${doi.owners.length > 1 ? 's' : ''}`}>
              {doi.owners.map((owner) => (
                <div key={owner.name}>
                  {owner.ror ? (
                    <a
                      href={owner.ror}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {owner.name}
                    </a>
                  ) : (
                    owner.name
                  )}
                  {owner.location && (
                    <span className="text-muted"> ({owner.location})</span>
                  )}
                </div>
              ))}
            </MetadataElement>
          )}

          {operationalStart &&
            (operationalEnd ? (
              <MetadataElement title="Operational period">
                {`${operationalStart} – ${operationalEnd}`}
              </MetadataElement>
            ) : (
              <MetadataElement title="Operational since">
                {operationalStart}
              </MetadataElement>
            ))}

          <MetadataElement title="Location">{doi.location}</MetadataElement>

          <MetadataElement title="Publisher">
            <Publisher doi={doi} />
          </MetadataElement>

          <MetadataElement title="Deposit date">{createdDate}</MetadataElement>
        </Col>
      </Card.Body>
    </Card>
  );
}
